import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from './auth.module'
import { archetype } from './archetype.module'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    archetype
  }
})

if (window.Cypress) {
  window.__store__ = store
}

export default store
